import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: '100%'
    }
  }
}));

export default function TextInput(props) {
  const classes = useStyles();

  return (
    <form className={classes.root} noValidate autoComplete="off">
      {props.fieldConfiguration.required ?
      <TextField
        required
        value={props.value}
        id="outlined-basic"
        label={props.fieldConfiguration.columnName}
        variant="outlined"
        onChange={(event)=> props.onClickFunction(props.fieldConfiguration.fieldName,event.target.value)}
        autoComplete={props.fieldConfiguration.autocomplete}
        InputProps={{
          readOnly: ( props.fieldConfiguration.isReadOnly || props.disableReadonly )
        }}
        placeholder={props.placeHolder}
      />
      :
      <TextField
        value={props.value}
        id="outlined-basic"
        label={props.fieldConfiguration.columnName}
        variant="outlined"
        onChange={(event)=> props.onClickFunction(props.fieldConfiguration.fieldName,event.target.value)}
        autoComplete={props.fieldConfiguration.autocomplete}
        InputProps={{
          readOnly: ( props.fieldConfiguration.isReadOnly || props.disableReadonly )
        }}
        placeholder={props.placeHolder}
      />
      }
    </form>
  );
}
